import script from "./ResultView.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultView.vue?vue&type=script&setup=true&lang=js"

import "./ResultView.vue?vue&type=style&index=0&id=c4e4a1d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4e4a1d2"]])

export default __exports__